<template>
  <Menu
    v-slot="{ close }"
    as="div"
    class="relative inline-block text-left  h-auto"
  >
    <div class="z-100">
      <MenuButton
        ref="menuButton"
        :disabled="disabled"
        class="items-center flex"
        @click="onClick(close)"
      >
        <slot name="trigger">
          <stormy-icon-button
            :disabled="disabled"
            :icon="icon"
            :variant="iconVariant"
            :size="iconSize"
          />
        </slot>
      </MenuButton>
    </div>
    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="bg-white rounded-t-md absolute rounded-md shadow-md  mt-2 z-500 border"
        :class="[originClass, widthClass]"
      >
        <div
          v-if="!hideHeader && hasHeader"
          class=" py-2.5 px-4 bg-stone-50 text-sm text-gray-900  divide-y rounded-t-md border-b border-gray-100 z-500 "
          :class="hoverHeader ? 'hover:bg-stone-100' : ''"
        >
          <slot name="header" />
        </div>
        <div
          class="divide-gray-100 divide-y rounded-none space-y-1 pb-1 bg-white rounded-t-md z-500 "
          :class="[hasHeader ? '' : 'rounded-t-md', hasFooter ? '' : 'rounded-b-md']"
        >
          <slot />
        </div>
        <div
          v-if="hasFooter && !hideFooter"
          class=" py-2.5 px-4 bg-stone-50 text-sm text-gray-900  divide-y rounded-b-md border-t z-500 "
          :class="hoverFooter ? 'hover:bg-stone-100' : ''"
        >
          <slot name="footer" />
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>
<script setup>
import { Menu, MenuButton, MenuItems } from '@headlessui/vue'

import { computed, ref, useSlots } from 'vue'

import { useProp } from '@/composables/useProp.js'

const props = defineProps({
  icon: useProp(String, 'tabler-dots'),
  iconSize: useProp(String, 'md'),
  iconVariant: useProp(String, 'ghost'),
  shortcut: useProp([String, Number]),
  disabled: useProp(Boolean),
  hoverHeader: useProp(Boolean),
  hoverFooter: useProp(Boolean),
  hideFooter: useProp(Boolean),
  hideHeader: useProp(Boolean),
  widthClass: useProp(String, 'w-72'),
  labelClass: useProp(String),
  label: useProp(String),
  origin: useProp(String, 'top-right'),
  iconStrokeWidth: useProp(Number, 1.5)
})

const originClass = computed(() => {
  return {
    'top-right': 'origin-top-right right-0',
    'top-left': 'origin-top-left left-0',
    'bottom-left': 'origin-bottom-left bottom-10 left-0',
    'bottom-right': 'origin-bottom-right bottom-10 right-0',
    top: 'origin-top left-1/2 transform -translate-x-1/2',
    bottom: 'origin-bottom left-1/2 transform -translate-x-1/2'
  }[props.origin]
})

const $slots = useSlots()
const hasHeader = computed(() => !!$slots.header && !props.hideHeader)
const hasFooter = computed(() => !!$slots.footer)

const closeFunction = ref(null)
const onClick = (close) => { closeFunction.value = close }

defineExpose({ closeFunction })

</script>
